import {observer} from "mobx-react";
import {useContext} from "react";
import {Typography, Chip} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {Frame} from "../common/Frame";
import {LessonStoreContext} from "../../stores/LessonStore";
import {D} from "../../Constants";

export const LessonHeader = observer(() => {
  const store = useContext(LessonStoreContext);
  const theme = useTheme();

  if (!store) return null;

  const stats = store.statistics;
  const hasThumbnail = !!store.lesson?.thumbnailUrl;

  return (
    <Frame
      padding={3}
      direction="column"
      gap={2}
    >
      <Frame row gap={3}>
        {/* Thumbnail */}
        {hasThumbnail ? (
          <img
            src={store.lesson!.thumbnailUrl!}
            alt="Thumbnail"
            style={{
              width: 250,
              height: 250,
              objectFit: 'cover',
              borderRadius: D.radius(1),
              flexShrink: 0,
            }}
          />
        ) : (
          <Frame
            center
            radius={1}
            style={{
              width: 250,
              height: 250,
              flexShrink: 0,
              backgroundColor: theme.palette.shade2,
            }}
          >
            <MenuBookIcon style={{fontSize: 48, color: theme.palette.primary.dark, opacity: 0.5}}/>
          </Frame>
        )}

        {/* Title & Description */}
        <Frame direction="column" gap={1} grow>
          <Typography variant="h4" fontWeight="bold">
            {store.lesson?.title}
          </Typography>

          {store.lesson?.description && (
            <Typography
              variant="body1"
              color="textSecondary"
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {store.lesson.description}
            </Typography>
          )}
        </Frame>
      </Frame>

      {stats && (
        <Frame row gap={2} wrap>
          <Chip
            icon={<MenuBookIcon style={{marginLeft: '6px'}}/>}
            label={`${stats.chapters} chapters`}
            size="small"
            variant="outlined"
          />
          <Chip
            icon={<OndemandVideoIcon style={{marginLeft: '6px'}}/>}
            label={`${stats.videoExamples} video examples`}
            size="small"
            variant="outlined"
          />
          <Chip
            icon={<AccessTimeIcon style={{marginLeft: '6px'}}/>}
            label={`~${stats.durationMinutes} minutes`}
            size="small"
            variant="outlined"
          />
        </Frame>
      )}
    </Frame>
  );
});
